import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import Avatar from './avatar.gjs';
import Component from '@glimmer/component';
import styles from './contact-list-item.module.scss';

export default class ContactListItem extends Component {
  @service messaging;
  @service messagingNavigation;

  get contacts() {
    let { couple } = this.args.contact;
    return couple?.length ? couple : [this.args.contact];
  }

  get userNames() {
    return this.contacts.map(user => user.name).join(' & ');
  }

  @action
  async openConversationWithContact() {
    const conversation = this.messaging.findOrCreateConversationWithContact(this.args.contact);
    this.messagingNavigation.toConversation(conversation);
  }

  <template>
    <li
      class="{{styles.component}} contact-list-item"
      data-test-contact={{@contact.id}}
      data-test-contact-list-item
      role="button"
      tabindex="0"
      aria-label={{t "emc.contact_list_item.select_aria_label" userNames=this.userNames}}
      {{on "click" this.openConversationWithContact}}
    >
      <Avatar @users={{this.contacts}} />
      <div class="item-details">
        <div class="top-line">
          <span class="user-names" data-test-user-names>{{this.userNames}}</span>
        </div>
      </div>
    </li>
  </template>
}
